// Label field that automatically saves the file label as you type
import React from "react";
import Cx from "classnames";
import { v4 as uuid } from "uuid";
import { instantSave } from "../../helpers";

import NoteItem from "./NoteItem";
import styles from "./Notes.scss";

export default class Notes extends React.Component {
  state = {
    items: JSON.parse(this.props.items || []),
    hiddenVal: JSON.parse(this.props.items || []), // this omits new blank notes
  };

  handleToggleArchive = (id) => {
    const { items } = this.state;
    const newItems = items
      .map((item) => {
        if (item.id === id || item.uuid === id) {
          if (!item.body) return;

          return {
            ...item,
            archived: !item.archived,
          };
        }
        return item;
      })
      .filter(Boolean);

    this.setState({ items: newItems });
  };

  handleChange = (val, id) => {
    const { items } = this.state;
    const newItems = items.map((item) => {
      if (item.id === id || item.uuid === id) {
        return {
          ...item,
          body: val,
        };
      }
      return item;
    });

    this.setState({ items: newItems });
  };

  componentDidUpdate = () => {
    const { items, hiddenVal } = this.state;
    const newHiddenVal = items.filter((i) => i.body);

    if (
      window.unsavedChanges &&
      JSON.stringify(hiddenVal) !== JSON.stringify(newHiddenVal)
    ) {
      // debounce instant updates (wait 400ms)
      window.unsavedChanges(true);
      clearTimeout(window.notesChangeDebounce);
      window.notesChangeDebounce = setTimeout(() => {
        instantSave();
      }, 400);

      this.setState({ hiddenVal: newHiddenVal });
    }
  };

  handleClickNew = (e) => {
    e.preventDefault();
    const { userId } = this.props;
    const { items } = this.state;

    if (!items.length || [...items].reverse()[0].body) {
      items.push({
        id: null,
        uuid: uuid(),
        body: "",
        user_id: userId,
      });

      setTimeout(() => {
        const el = document.querySelector(
          `.${styles.item}:last-child textarea`
        );
        el.focus();
      }, 100);

      this.setState({ items });
    }
  };

  render() {
    const { recordType, recordId } = this.props;
    const { items, hiddenVal } = this.state;
    const notArchivedItems = items.filter((i) => !i.archived);
    const archivedItems = items.filter((i) => i.archived);

    return (
      <>
        <div
          className={Cx("panel", {
            closed: !((notArchivedItems.length && recordId) || !recordId),
          })}
        >
          <div className="panel-title">Notes&nbsp;&nbsp;📔</div>
          <input
            type="hidden"
            name={`${recordType}[note]`}
            value={JSON.stringify(hiddenVal)}
          />
          {!!notArchivedItems.length && (
            <div className={styles.list}>
              {notArchivedItems.map((item) => (
                <NoteItem
                  key={item.id || item.uuid}
                  item={item}
                  onChange={this.handleChange}
                  onToggleArchive={this.handleToggleArchive}
                />
              ))}
            </div>
          )}
          <button className={styles.add} onClick={this.handleClickNew}>
            Add Note
          </button>
        </div>
        <div
          className="panel closed"
          style={{ display: archivedItems.length ? "block" : "none" }}
        >
          <div className="panel-title">Archived Notes&nbsp;&nbsp;📔</div>
          {!!archivedItems.length && (
            <div className={styles.list}>
              {archivedItems.map((item) => (
                <NoteItem
                  key={item.id || item.uuid}
                  item={item}
                  onChange={this.handleChange}
                  onToggleArchive={this.handleToggleArchive}
                />
              ))}
            </div>
          )}
        </div>
      </>
    );
  }
}
